import {Outlet} from 'react-router-dom';
import {Sidebar} from '@/components/app/Sidebar';
import {Topbar} from '@/components/app/Topbar';
import {Toaster} from '@/components/app/Toaster';

export function AppShell() {
  return (
    <div className="flex h-screen w-screen overflow-hidden app-backdrop">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto scrollbar-thin">
          <div className="max-w-[1600px] mx-auto px-6 py-6">
            <Outlet />
          </div>
        </main>
      </div>
      <Toaster />
    </div>
  );
}
